import { Form } from 'antd'

import { useHealthInsuranceValues } from './HealthInsuranceContext'
import { CreditFields } from '../CreditFields'
import { CustomerFields } from '../PersonsFields'

export const CustomerStep = () => {
  const { isEditable } = useHealthInsuranceValues()
  const price = Form.useWatch('price', { preserve: true })
  const orderPrice = Form.useWatch('order_price', { preserve: true })

  const maxPrice = isEditable
    ? price?.amount - orderPrice?.amount
    : price?.amount

  return (
    <>
      <CustomerFields isEditable={isEditable} />
      <CreditFields orderPrice={maxPrice} isEditable={isEditable} />
    </>
  )
}
